(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-slider"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var activeSlide = 0;
  var slideInterval = 6000; // Time in milliseconds for each slide
  var autoSlide;
  var sliderWrapper = document.querySelector(".slider-wrapper");
  var sliderItems = document.querySelectorAll(".slider-item");
  var dots = document.getElementById('dots');

  if (!sliderWrapper) {
    console.error("Slider wrapper not found!");
    return;
  }

  // Clone slides for infinite loop effect if more than one slide
  function cloneSlides() {
    if (sliderItems.length > 1) {
      sliderItems.forEach(item => {
        var clone = item.cloneNode(true);
        sliderWrapper.appendChild(clone);
      });
      sliderItems = document.querySelectorAll(".slider-item"); // Update the NodeList
    }
  }

  function updateMediaSrc() {
    sliderItems.forEach(function(item) {
      var img = item.querySelector('.dynamicImage');
      var video = item.querySelector('video.slider-video');

      // Handle image source
      if (img) {
        var mobileSrc = img.getAttribute('data-mobile-src');
        var desktopSrc = img.getAttribute('src');
        img.src = window.innerWidth <= 780 ? mobileSrc : desktopSrc;
      }

      // Handle video source
      if (video) {
        var mobileSrc = video.getAttribute('data-mobile');
        var desktopSrc = video.getAttribute('data-web');
        video.src = window.innerWidth <= 780 ? mobileSrc : desktopSrc;
        video.load(); // Reload video with new source
      }
    });
  }

  function createSlider() {
    if (sliderItems.length > 1) {
      cloneSlides(); // Clone slides for infinite effect
      sliderItems.forEach((item, index) => {
        if (index < sliderItems.length / 2) { // Only create dots for original slides
        var dot = document.createElement('li');
        dot.classList.add('list-inline-item');
        dot.setAttribute('data-index', index);
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.setAttribute('tabindex', '0');
        dot.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
  
        dot.addEventListener('click', function () {
          clearInterval(autoSlide);
          activeSlide = Number(this.getAttribute('data-index'));
          showSlide();
          startAutoSlide();
          updateDotAccessibility();
        });
  
        dot.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.click();
          }
        });
  
        dots.appendChild(dot);
      }
      });
      startAutoSlide();
    }
    updateMediaSrc(); // Call to update media sources
    showSlide();
  }

  function showSlide() {
    if (!sliderWrapper) return;

    var slideWidth = sliderItems[0].offsetWidth;
    sliderWrapper.style.transition = 'transform 0.5s ease';
    sliderWrapper.style.transform = `translateX(-${slideWidth * activeSlide}px)`;

    sliderItems.forEach(item => item.classList.remove('active'));
    sliderItems[activeSlide].classList.add('active');

    updateDots();
  }

  function updateDots() {
    var dotsChildren = dots.getElementsByTagName('li');
    Array.from(dotsChildren).forEach(dot => dot.classList.remove('active'));
    if (dotsChildren[activeSlide % (sliderItems.length / 2)]) {
      dotsChildren[activeSlide % (sliderItems.length / 2)].classList.add('active');
    }
  }

  function nextSlide() {
    activeSlide++;
    if (activeSlide >= sliderItems.length) {
      activeSlide = 0;
      sliderWrapper.style.transition = 'none';
      sliderWrapper.style.transform = 'translateX(0)';
      setTimeout(() => {
        sliderWrapper.style.transition = 'transform 0.5s ease';
        activeSlide = 1;
        showSlide();
      }, 50);
    } else {
      showSlide();
    }
  }

  function startAutoSlide() {
    if (sliderItems.length > 1) {
      autoSlide = setInterval(nextSlide, slideInterval);
    }
  }

  createSlider();

  document.querySelector('.slider').addEventListener('mouseover', function() {
    clearInterval(autoSlide);
  });

  document.querySelector('.slider').addEventListener('mouseout', function() {
    startAutoSlide();
  });

  window.addEventListener('resize', function() {
    updateMediaSrc(); // Call to update sources on resize
    showSlide();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["img-slider"] && !window.DesignMode) return;
  try {
    
  // screenWidth

  var activeSlide = 0;
  var lastSlide = 0;
  var startX, startY;

function init() {
    var dots = document.getElementById('dots');
    createSlider();
    renderVideo()
  }

  init();
  
  function renderVideo(){
    var sliderItem = document.querySelectorAll(".slider-item");
      var renderElem = sliderItem[activeSlide].querySelector('#videoWrapper');
   

      let videoWebURL =  renderElem.dataset.web;
      let videoMobileURL =  renderElem.dataset.mobile;
      
      if(window.screen.width > 780) {
         renderElem.innerHTML = `<source src="${videoWebURL}" type="video/mp4">`
        
      }
      else {
        renderElem.innerHTML = ` <source src="${videoMobileURL}" type="video/mp4">`
      }

  }
function handleTouchStart (e){
    startX = e.touches[0].clientX;
  startY = e.touches[0].clientY;
}
  function runSwapVideo(e){
    var endX = e.changedTouches[0].clientX;
    var endY = e.changedTouches[0].clientY;
    var deltaX = startX - endX;
    var deltaY = startY - endY;
    var sliderItem = document.querySelectorAll(".slider-item");
    let dotsChild = dots.getElementsByTagName('li');
 
    if (Math.abs(deltaX) > 50) {
    (deltaX > 0) ? activeSlide = (activeSlide === sliderItem.length - 1) ? 0 : activeSlide + 1 :  activeSlide = (activeSlide === 0) ? sliderItem.length - 1 : activeSlide - 1
    }
        for (i = 0; i < sliderItem.length; i++) {
          sliderItem[i].classList.remove('active');  
          dotsChild[i].classList.remove('active');
        }
      sliderItem[activeSlide].classList.add('active');
      dotsChild[activeSlide].classList.add('active');
    
    // re-render video
    renderVideo();
}
  
  function createSlider() {
    var sliderItem = document.querySelectorAll(".slider-item");
      sliderItem[activeSlide].classList.add("active");
    for (i = 0; i < sliderItem.length; i++) {
      dots.appendChild(document.createElement('li'));
      let dotsChild = dots.getElementsByTagName('li')[i];
      dotsChild.classList.add('list-inline-item');
      dotsChild.setAttribute("id", i);
      dotsChild.innerHTML = i;
      sliderItem[i].addEventListener("touchend",runSwapVideo);
      sliderItem[i].addEventListener("touchstart",handleTouchStart, {passive: true});
      dotsChild.addEventListener("click",runSlider);
    }
    dots.getElementsByTagName('li')[activeSlide].classList.add('active');
  }
  function runSlider(){
    var sliderItem = document.querySelectorAll(".slider-item");
     let dotsChild = dots.getElementsByTagName('li');
      activeSlide = Number(this.getAttribute("id"));

    for (i = 0; i < sliderItem.length; i++) {
          sliderItem[i].classList.remove('active');  
          dotsChild[i].classList.remove('active');
        }
      sliderItem[activeSlide].classList.add('active');
      dotsChild[activeSlide].classList.add('active');
    
    // re-render video
    renderVideo();
}
function videoEnded(){
  alert("Video Ended")
   var sliderItem = document.querySelectorAll(".slider-item");
     let dotsChild = dots.getElementsByTagName('li');
      activeSlide = this.getAttribute("id");
        for (i = 0; i < sliderItem.length; i++) {
          sliderItem[i].classList.remove('active');  
          dotsChild[i].classList.remove('active');
        }
  if(sliderItem.lenght-1 == activeSlide){
    activeSlide=0;
  }else{
    activeSlide++;
  }
      sliderItem[activeSlide].classList.add('active');
      dotsChild[activeSlide].classList.add('active');
    
    // re-render video
    renderVideo();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  const shareButton = document.getElementById('share-button');
  const socialList = document.querySelector('.t4s-socials');
  const shareButtonContent = shareButton.querySelector('span');

  // Function to toggle the dropdown
  function toggleDropdown() {
      socialList.classList.toggle('show');
  }

  // Click event listener for the button
  shareButton.addEventListener('click', toggleDropdown);

  // Click event listener for the SVG icon inside the button
  shareButtonContent.addEventListener('click', (event) => {
      // Prevent the button from triggering the click event
      event.stopPropagation();
      toggleDropdown();
  });

  // Close the dropdown if the user clicks outside of it
  window.addEventListener('click', (event) => {
      if (!event.target.matches('#share-button') && !event.target.closest('.social-list')) {
          if (socialList.classList.contains('show')) {
              socialList.classList.remove('show');
          }
      }
  });

  } catch(e) { console.error(e); }
})();
})();
